// Environment-derived settings, read in one place.
export const FRONT_URL = process.env.REACT_APP_FRONTPAGE_URL;
